import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomStatusFilter from 'components/DataGrid/createColumns/CustomStatusFilter'
import { statusFilters, organizationTypeOptions } from 'components/Organizations/orgStatusOptions'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import React, { useMemo, useState } from 'react'

const OrganizationsFilters = ({
  filterModel,
  onSetFilter,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
}: {
  filterModel: GridFilterModel
  onSetFilter: (fieldName: string, selectedValues: string[]) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
}) => {
  const [filterStatus, setFilterStatus] = useState<string>('')
  const [filterType, setFilterType] = useState<string>('')
  const memoizedStatusFilters = useMemo(() => statusFilters, [])
  const memoizedOrganizationTypeOptions = useMemo(() => organizationTypeOptions, [])
  return (
    <>
      <CustomFiltersMenu
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={'icon.organizations'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <CustomStatusFilter
          context={'type'}
          options={memoizedOrganizationTypeOptions}
          setterFn={setFilterType}
          filterModel={filterModel}
          value={filterType}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'status'}
          options={memoizedStatusFilters}
          setterFn={setFilterStatus}
          filterModel={filterModel}
          value={filterStatus}
          onChange={onSetFilter}
        />
      </CustomFiltersModal>
    </>
  )
}
export default OrganizationsFilters
